<template>
  <section class="mb-4">
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <nav class="panel is-warning">
          <p class="panel-heading is-size-6">
            {{ $t('attributes.product_code') }}：{{ product_code }}
          </p>

          <div class="panel-block">
            <div class="control">
              <form-group
                horizontal
                name="name"
                :label="$t('attributes.product') + $t('attributes.name')"
              >
                <b-input
                  v-model="form.name"
                  name="name"
                  :placeholder="
                    $t('message.please_input') +
                      $t('attributes.product') +
                      $t('attributes.name')
                  "
                  expanded
                ></b-input>
              </form-group>

              <form-group
                horizontal
                name="alias"
                attribute="attributes.product_alias"
                :label="$t('attributes.product_alias')"
              >
                <b-field>
                  <b-input
                    v-model="form.alias"
                    name="alias"
                    :placeholder="
                      $t('message.please_input') +
                        $t('attributes.product_alias')
                    "
                    expanded
                  >
                  </b-input>
                  <p class="control">
                    <a
                      :href="helpImageUrl('團別名稱.png')"
                      @click.prevent="
                        onClickImage(helpImageUrl('團別名稱.png'))
                      "
                    >
                      <img
                        :src="helpImageUrl('團別名稱.png')"
                        alt="團別大標"
                        width="64"
                      />
                    </a>
                  </p>
                </b-field>
              </form-group>

              <b-field horizontal>
                <template #label>
                  {{ $t('attributes.operator_remark') }}
                  <b-tooltip
                    type="is-dark"
                    :label="$t('attributes.operator_remark_label')"
                  >
                    <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                  </b-tooltip>
                </template>
                <form-group
                  name="remark5"
                  attribute="attributes.operator_remark"
                  expanded
                >
                  <b-input
                    v-model="form.remark5"
                    name="remark5"
                    :placeholder="
                      $t('message.please_input') +
                        $t('attributes.operator_remark') +
                        $t('attributes.operator_remark_max_length')
                    "
                    expanded
                  ></b-input>
                </form-group>
              </b-field>

              <form-group
                horizontal
                name="external_url"
                :label="$t('attributes.external_url')"
              >
                <b-input
                  v-model="form.external_url"
                  name="external_url"
                  :placeholder="
                    $t('message.please_input') + $t('attributes.external_url')
                  "
                  expanded
                ></b-input>
              </form-group>

              <b-field horizontal>
                <div class="columns">
                  <div class="column">
                    <form-group
                      name="shelve_on"
                      :label="$t('attributes.shelve_status')"
                    >
                      <b-switch
                        v-model="form.shelve_on"
                        name="shelve_on"
                      ></b-switch>
                    </form-group>
                  </div>

                  <div class="column">
                    <form-group
                      name="situation"
                      :label="$t('attributes.situation')"
                    >
                      <b-select v-model="form.situation" name="situation">
                        <option
                          v-for="option in situationTypes"
                          :key="option.id"
                          :value="option.id"
                        >
                          <!-- eslint-disable-next-line -->
                          <p v-html="option.name"></p>
                        </option>
                      </b-select>
                    </form-group>
                  </div>

                  <div class="column">
                    <form-group
                      name="airline"
                      :label="$t('attributes.airline')"
                    >
                      <b-autocomplete
                        ref="airlineInput"
                        v-model="selectedAirline"
                        name="airline"
                        field="display_name"
                        :data="airlines"
                        :placeholder="
                          $t('message.please_input') + $t('attributes.airline')
                        "
                        :open-on-focus="true"
                        @typing="onSelectingAirline"
                        @select="onSelectedAirline"
                      >
                        <template #default="props">
                          <div class="media">
                            <div class="media-left" style="width: 20px">
                              {{ props.option.code }}
                            </div>
                            <div class="media-content">
                              {{ props.option.name }}
                              ({{ props.option.english_name }})
                            </div>
                          </div>
                        </template>
                        <template #empty>
                          No results found
                        </template>
                      </b-autocomplete>
                    </form-group>
                  </div>
                </div>
              </b-field>

              <b-field horizontal>
                <div class="columns">
                  <div class="column">
                    <form-group
                      name="deposit"
                      :label="$t('attributes.deposit')"
                    >
                      <b-input
                        v-model.number="form.deposit"
                        name="deposit"
                        type="number"
                        min="0"
                        :placeholder="
                          $t('message.please_input') + $t('attributes.deposit')
                        "
                      ></b-input>
                    </form-group>
                  </div>
                  <div class="column">
                    <form-group
                      name="hide_price"
                      :label="$t('attributes.hide_price')"
                    >
                      <b-select v-model="form.hide_price" name="hide_price">
                        <option value="N">
                          {{ $t('attributes.display') }}
                        </option>
                        <option value="Y">
                          {{ $t('attributes.hide') }}
                        </option>
                      </b-select>
                    </form-group>
                  </div>
                  <div class="column">
                    <form-group
                      name="show_up"
                      :label="$t('attributes.show_up')"
                    >
                      <b-select v-model="form.show_up" name="show_up">
                        <option value="Y">{{ $t('attributes.yes') }}</option>
                        <option value="N">{{ $t('attributes.no') }}</option>
                      </b-select>
                    </form-group>
                  </div>
                </div>
              </b-field>
              <b-field horizontal>
                <div class="columns">
                  <div class="column">
                    <form-group
                      name="tip_fee"
                      :label="$t('attributes.tip_fee')"
                    >
                      <b-field>
                        <b-select v-model="form.tip_flag" name="tip_flag">
                          <option value="Y">
                            {{ $t('attributes.included') }}
                          </option>
                          <option value="N">
                            {{ $t('attributes.excluded') }}</option
                          >
                        </b-select>
                        <b-input
                          v-model.number="form.tip_fee"
                          name="tip_fee"
                          type="number"
                          min="0"
                          :placeholder="
                            $t('message.please_input') +
                              $t('attributes.tip_fee')
                          "
                          expanded
                        ></b-input>
                      </b-field>
                    </form-group>
                  </div>

                  <div class="column">
                    <form-group
                      name="insurance_fee"
                      attributes="tax_fee"
                      :label="$t('attributes.tax_fee')"
                    >
                      <b-field>
                        <b-select
                          v-model="form.insurance_flag"
                          name="insurance_flag"
                        >
                          <option value="Y">
                            {{ $t('attributes.included') }}
                          </option>
                          <option value="N">
                            {{ $t('attributes.excluded') }}
                          </option>
                        </b-select>
                        <b-input
                          v-model.number="form.insurance_fee"
                          name="insurance_fee"
                          type="number"
                          min="0"
                          :placeholder="
                            $t('message.please_input') +
                              $t('attributes.tax_fee')
                          "
                          expanded
                        ></b-input>
                      </b-field>
                    </form-group>
                  </div>
                  <div class="column">
                    <form-group
                      name="visa_fee"
                      :label="$t('attributes.visa_fee')"
                    >
                      <b-field>
                        <b-select v-model="form.visa_flag" name="visa_flag">
                          <option value="Y">
                            {{ $t('attributes.included') }}
                          </option>
                          <option value="N">
                            {{ $t('attributes.excluded') }}
                          </option>
                          <option value="X">
                            {{ $t('attributes.visa_free') }}
                          </option>
                        </b-select>
                        <b-input
                          v-model.number="form.visa_fee"
                          name="visa_fee"
                          type="number"
                          min="0"
                          :placeholder="
                            $t('message.please_input') +
                              $t('attributes.visa_fee')
                          "
                          expanded
                        ></b-input>
                      </b-field>
                    </form-group>
                  </div>
                </div>
              </b-field>
            </div>
          </div>

          <div class="panel-block">
            <b-button
              :loading="sending"
              type="is-danger is-light"
              native-type="submit"
              expanded
            >
              {{ $t('attributes.update_data') }}
            </b-button>
          </div>

          <div class="panel-block">
            <div class="field is-grouped" style="width: 100%;">
              <div class="control is-expanded">
                <b-button
                  type="is-info"
                  size="is-small"
                  outlined
                  expanded
                  @click.stop.prevent="isTravelerTypeModalActive = true"
                >
                  價格進階維護
                </b-button>
              </div>
              <div class="control is-expanded">
                <b-button
                  type="is-info"
                  size="is-small"
                  outlined
                  expanded
                  @click.stop.prevent="isCountriesModalActive = true"
                >
                  {{ $t('attributes.country_flag') }}
                </b-button>
              </div>
              <div class="control is-expanded">
                <b-button
                  type="is-info"
                  size="is-small"
                  outlined
                  expanded
                  @click.stop.prevent="isWeatherModalActive = true"
                >
                  {{ $t('attributes.city_weather') }}
                </b-button>
              </div>
              <div class="control is-expanded">
                <b-button
                  type="is-info"
                  size="is-small"
                  outlined
                  expanded
                  @click.stop.prevent="isFeatureModalActive = true"
                >
                  行程特色
                </b-button>
              </div>
            </div>
          </div>
        </nav>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isTravelerTypeModalActive" :width="1200">
      <div class="card">
        <div class="card-content">
          <traveler-type-list :product="product" @updated="onUpdated" />
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isCountriesModalActive" :width="1200">
      <div class="card">
        <div class="card-content">
          <countries-form :product="product" @updated="onUpdated" />
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isWeatherModalActive" :width="1200">
      <div class="card">
        <div class="card-content">
          <weathers-form :product="product" @updated="onUpdated" />
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isFeatureModalActive" :width="1200">
      <div class="card">
        <div class="card-content">
          <feature-form :product="product" @updated="onUpdated" />
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
import {
  required,
  numeric,
  minValue,
  maxLength
} from 'vuelidate/lib/validators'
import { AIRLINE_API, PRODUCTS_API } from '@/utils/apis'
import TravelerTypeList from './TravelerTypeList'
import CountriesForm from './CountriesForm'
import WeathersForm from './WeathersForm'
import FeatureForm from './FeatureForm'
import notifyService from '@/services/notifyService'

export default {
  name: 'ProductAdvanceForm',
  components: {
    TravelerTypeList,
    CountriesForm,
    WeathersForm,
    FeatureForm
  },

  props: {
    product: {
      required: true,
      type: Object
    },
    situationTypes: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      sending: false,

      product_code: this.product.code,
      area_code: this.product.area_code,
      form: this.extractFormValues(this.product),

      airlines: [],
      selectedAirline: null,

      isTravelerTypeModalActive: false,
      isCountriesModalActive: false,
      isWeatherModalActive: false,
      isFeatureModalActive: false,

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      name: { required },
      alias: { maxLength: maxLength(100) },
      remark5: {},
      external_url: { maxLength: maxLength(500) },
      shelve_on: {},
      situation: {},
      airline: {},

      deposit: { required, numeric, minValue: minValue(0) },
      tip_flag: {},
      tip_fee: { required, numeric, minValue: minValue(0) },
      insurance_flag: {},
      insurance_fee: { required, numeric, minValue: minValue(0) },
      visa_flag: {},
      visa_fee: { required, numeric, minValue: minValue(0) },
      hide_price: {},
      show_up: {}
    }
  },
  computed: {
    ...mapGetters('app', ['hasPermission'])
  },
  watch: {
    product(newProduct) {
      this.product_code = newProduct.code
      this.area_code = newProduct.area_code
      this.form = this.extractFormValues(newProduct)

      this.selectedAirline = null
      this.loadData()
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      await this.getAirlines(this.form.airline)
      this.loading = false
    },
    async getAirlines(search) {
      const api = `${AIRLINE_API}/list`
      const params = {
        search: search
      }

      try {
        const res = await this.axios.get(api, { params })
        this.airlines = res.data.data.map(air => ({
          ...air,
          code: air.code.trim(),
          name: air.name.trim(),
          english_name: air.english_name ? air.english_name.trim() : '',
          display_name: this.formatAirlineName(air)
        }))

        if (!this.selectedAirline) {
          const air = this.airlines.find(a => a.code === search)
          this.selectedAirline = air && air.display_name
        }
      } catch (e) {
        this.airlines = []

        notifyService.fetch_error('airline', e)
      }
    },
    extractFormValues(data) {
      return {
        name: data.name,
        alias: data.alias,
        remark5: data.remark5,
        external_url: data.external_url,

        shelve_on: data.shelve_on,
        situation: data.situation,
        airline: data.airline,

        deposit: data.deposit || 0,
        tip_flag: data.tip_flag ? data.tip_flag.trim() : 'N',
        tip_fee: data.tip_fee || 0,
        insurance_flag: data.insurance_flag ? data.insurance_flag.trim() : 'N',
        insurance_fee: data.insurance_fee || 0,
        visa_flag: data.visa_flag ? data.visa_flag.trim() : 'N',
        visa_fee: data.visa_fee || 0,
        hide_price: data.hide_price ? data.hide_price.trim() : 'N',
        show_up: data.show_up ? data.show_up.trim() : 'N'
      }
    },
    onSelectingAirline: debounce(function(search) {
      this.getAirlines(search)
    }, 500),
    onSelectedAirline(option) {
      this.form.airline = option && option.code.trim()
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      try {
        const api = `${PRODUCTS_API}/${this.product_code}/advance`

        this.sending = true
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onUpdated(product) {
      this.$emit('updated', product)
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  select {
    width: 150px;
  }
}
</style>
